import { EmployerAgreementsChangeContributionService } from '@festina/life-general-types/life/services/EmployerAgreementsChangeContributionService'
import { useFestinaMutation } from '@festina-life/authentication'

type Props = {
  tenantId: string
  employerAgreementId: string
}

const method =
  EmployerAgreementsChangeContributionService.changeContributionDataServicePostEntity

type MethodParam = NonNullable<Parameters<typeof method>[0]['requestBody']>

export const useSubmitChangeContributionDataCommand = ({
  tenantId,
  employerAgreementId,
}: Props) =>
  useFestinaMutation({
    component: 'life',
    roles:
      EmployerAgreementsChangeContributionService.changeContributionDataServicePostEntity_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({
        xTenantId: tenantId,
        employerAgreementId,
        requestBody: arg,
      })
    },
  })
